import CalculatorIcon from '../../../icons/CalculatorIcon.svg';
import DocumentIcon from '../../../icons/DocumentIcon.svg';
import AvailableProductsIcon from '../../../icons/availableProducts.svg';
import User from '../../../icons/user.svg';

const availableProductUrl = process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST ? `${process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST}/inscapitasweb/ProductSearch.aspx` : 'https://ideas-qa07.msdwis.com/inscapitasweb/ProductSearch.aspx';

export const NeedsAnalysisList = [
    {
        name: 'Needs Analysis',
        key: 'needs-analysis',
        isShowOnHomePage: true,
        isShowOnlyOnHomePage: false,
        isRedirectLink: false,
        href: '/InsuranceTools/NeedsAnalysis',
        subText: '',
        categories: [],
        target: '_blank',
        icon: CalculatorIcon,
        filterKey: 'disability',
        backgroundImage: '/tools/NeedsAnalysisImage.png',
    },
    {
        name: 'Policy Review',
        key: 'policy-review',
        isShowOnHomePage: true,
        isShowOnlyOnHomePage: false,
        isRedirectLink: false,
        href: '/policyReview',
        subText: '',
        categories: [],
        target: '_blank',
        icon: DocumentIcon,
        filterKey: 'disability',
        backgroundImage: '/tools/PolicyReviewImage.png',
    },
    {
        name: 'Available Products',
        key: 'available-products',
        isShowOnHomePage: false,
        isShowOnlyOnHomePage: false,
        isRedirectLink: false,
        href: availableProductUrl,
        subText: 'See Product availability by Type and State',
        categories: [],
        target: '_blank',
        icon: AvailableProductsIcon,
        filterKey: 'disability',
        backgroundImage: '/tools/NeedsAnalysisImage.png',
    },
    {
        name: 'Morgan Stanley Insurance Licensing Tool',
        key: 'morgan-stanley-insurance-licensing-tool',
        isShowOnHomePage: true,
        isShowOnlyOnHomePage: true,
        isRedirectLink: true,
        href: '',
        subText: '',
        categories: [],
        target: '_blank',
        icon: AvailableProductsIcon,
        filterKey: 'disability',
        backgroundImage: '/tools/NeedsAnalysisImage.png',
    },
    {
        name: 'Morgan Stanley Insurance Specialist Page',
        key: 'morgan-stanley-insurance-specialist-page',
        isShowOnHomePage: true,
        isShowOnlyOnHomePage: true,
        isRedirectLink: true,
        href: '',
        subText: '',
        categories: [],
        target: '_blank',
        icon: User,
        filterKey: 'disability',
        backgroundImage: '/tools/NeedsAnalysisImage.png',
    },
]


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/NeedsAnalysisList.js